import get from 'lodash.get';

const getMultisiteMode = (rootState) => get(rootState, 'partner.properties.multisiteMode');

export default getMultisiteMode;
